import { Chip } from '@mui/material'

import { titleize } from 'inflection'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {string} props.status
 * @param {string} [props.size]
 */
export default function DeviceStatusChip({ status, size = undefined }) {
  const getConnectivityLabel = () => {
    switch (status) {
      case 'RMA':
        return status
      default:
        return titleize(status.toLowerCase())
    }
  }

  const getConnectivityColor = () => {
    switch (status) {
      case 'ONLINE':
      case 'PROVISIONED':
        return 'success.main'
      case 'OFFLINE':
      case 'RMA':
      case 'FAILURE':
        return 'error.main'
      default:
        return 'grey.500'
    }
  }

  return (
    <Chip
      size={size ?? 'small'}
      label={getConnectivityLabel()}
      sx={{
        userSelect: 'none',
        pointerEvents: 'none', // https://github.com/mui/material-ui/issues/46262 - can be removed on next MUI update (current 7.1.1)
        backgroundColor: getConnectivityColor(),
        '& .MuiChip-label': { color: 'white' },
      }}
    />
  )
}
